import { Link } from "react-router-dom";
import { Phone, Mail, Globe, Building2, MapPin } from "lucide-react";
import { company, directors } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0a1f44] text-gray-300">
      <div className="mx-auto max-w-7xl px-5 py-14 md:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="rounded-md bg-white p-4 inline-block">
              <img src={company.logo} alt={company.name} className="h-14 w-auto" />
            </div>
            <p className="mt-5 text-sm leading-relaxed text-gray-400">
              {company.tagline}
            </p>
            <p className="mt-4 text-xs text-gray-500">
              Company No. {company.companyNumber}
            </p>
          </div>

          <div>
            <h4 className="font-head text-sm font-700 uppercase tracking-widest text-white">
              Explore
            </h4>
            <div className="ld-accent-bar mt-3" />
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["About Us", "/about"],
                ["Services", "/services"],
                ["Products", "/products"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-gray-400 transition-colors hover:text-[#3b82f6]">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-head text-sm font-700 uppercase tracking-widest text-white">
              Contact
            </h4>
            <div className="ld-accent-bar mt-3" />
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Globe size={16} className="text-[#3b82f6]" />
                <span>{company.website}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#3b82f6]" />
                <a href={`mailto:${company.email}`} className="hover:text-[#3b82f6]">
                  {company.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#3b82f6]" />
                <span>Across mainland UK, including the Isle of Wight</span>
              </li>
              <li className="flex items-center gap-3">
                <Building2 size={16} className="text-[#3b82f6]" />
                <span>L&amp;D Controls Ltd</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-head text-sm font-700 uppercase tracking-widest text-white">
              Directors
            </h4>
            <div className="ld-accent-bar mt-3" />
            <ul className="mt-5 space-y-4 text-sm">
              {directors.map((d) => (
                <li key={d.email}>
                  <p className="font-semibold text-white">{d.name}</p>
                  <a
                    href={`tel:${d.phone.replace(/\s/g, "")}`}
                    className="flex items-center gap-2 text-gray-400 hover:text-[#3b82f6]"
                  >
                    <Phone size={13} /> {d.phone}
                  </a>
                  <a
                    href={`mailto:${d.email}`}
                    className="flex items-center gap-2 text-gray-400 hover:text-[#3b82f6]"
                  >
                    <Mail size={13} /> {d.email}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-gray-500 md:flex-row">
          <p>&copy; {new Date().getFullYear()} L&amp;D Controls Ltd. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p>Window Controls &middot; Automation &middot; Electrical Solutions</p>
            <Link to="/admin" className="text-gray-600 hover:text-[#3b82f6]">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
